"use client";
import { IoChatbubblesOutline } from "react-icons/io5";
import CustomButon from "../form/CustomButon";

export const StartChatButon = () => {
  return (
    <div className="fixed bottom-20 md:bottom-6 right-4 md:right-6 z-40">
      <CustomButon
        link={"/chat"}
        icon={<IoChatbubblesOutline size={22} style={{ color: "#ffff" }} />}
        className={"shadow-lg h-[45px] rounded-xl"}
      />
    </div>
  );
};
